require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-parks-tech-student-project-seattle-mayor.json") })
        }
      }, "path---blog-parks-tech-student-project-seattle-mayor");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-parks-tech-student-project-seattle-mayor!./.cache/json/blog-parks-tech-student-project-seattle-mayor.json
// module id = 1003
// module chunks = 231608221292675